import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["images", "background", "children", "className", "width", "forceChildren", "loadStrategy"];
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { getImages } from './Image.utils';
import ImageBase from '../../../../atoms/Image';
import { IMAGE_LOAD_STRATEGIES, LAZY_LOAD_STRATEGY } from '../../../../atoms/Image/Image.constants';
import Carousel from '../../../../darkmatter/Carousel';
import { ChildrenPropType, ImagesPropType, ImagePropType } from '../../../../services/proptypes';
import GridColumnFlex from '../../../GridColumnFlex';
import IndicatorGroup from '../../../IndicatorGroup';
var defaultProps = {
  background: false,
  children: null,
  className: '',
  width: null,
  forceChildren: false,
  loadStrategy: LAZY_LOAD_STRATEGY
};
export default function Image(_ref) {
  var images = _ref.images,
    background = _ref.background,
    children = _ref.children,
    className = _ref.className,
    width = _ref.width,
    forceChildren = _ref.forceChildren,
    loadStrategy = _ref.loadStrategy,
    imageProps = _objectWithoutProperties(_ref, _excluded);
  var finalImages = getImages(images);
  if (_isNil(finalImages) || _isEmpty(finalImages)) {
    return forceChildren ? children : null;
  }
  var isBackground = React.Children.count(children) > 0 || background;
  var multipleImages = finalImages.length > 1;
  function renderBackgroundContent(index) {
    var indicatorGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return /*#__PURE__*/React.createElement(ImageBase, _extends({
      src: finalImages[index]
    }, imageProps, {
      className: "column grid-column-flex text-center vertical-middle ".concat(className),
      background: true,
      as: "div",
      width: width,
      loadStrategy: loadStrategy
    }), children, indicatorGroup);
  }
  function renderImageContent(index) {
    var indicatorGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return /*#__PURE__*/React.createElement(GridColumnFlex, {
      className: "image-component",
      width: width
    }, /*#__PURE__*/React.createElement(ImageBase, _extends({
      src: finalImages[index],
      className: className
    }, imageProps)), indicatorGroup);
  }
  function renderCarousel() {
    return /*#__PURE__*/React.createElement(Carousel, {
      totalNumberOfItems: finalImages.length,
      autoScroll: true
    }, function (_ref2) {
      var currentIndex = _ref2.currentIndex,
        changeCurrentIndex = _ref2.changeCurrentIndex;
      var indicatorGroup = /*#__PURE__*/React.createElement(IndicatorGroup, {
        items: finalImages,
        currentIndex: currentIndex,
        changeCurrentIndex: changeCurrentIndex,
        align: isBackground ? 'right' : 'center'
      });
      return isBackground ? renderBackgroundContent(currentIndex, indicatorGroup) : renderImageContent(currentIndex, indicatorGroup);
    });
  }
  function renderSingleImage() {
    return isBackground ? renderBackgroundContent(0) : renderImageContent(0);
  }
  return multipleImages ? renderCarousel() : renderSingleImage();
}
Image.defaultProps = defaultProps;